module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }